/**
 * OAuthCallback Page
 * Handles the redirect from OAuth providers after authorization.
 * Writes result to localStorage (postMessage is blocked by COOP: same-origin),
 * then closes the popup window.
 * Route: /oauth/callback
 */

import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function OAuthCallback() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const platform = searchParams.get('platform') ?? '';
    const success = searchParams.get('success') === 'true';
    const error = searchParams.get('error') ?? undefined;

    // Write to localStorage — the opener listens for storage events
    // (window.opener is null due to Helmet's COOP: same-origin header)
    localStorage.setItem(
      'oauth_callback',
      JSON.stringify({ platform, success, error, ts: Date.now() })
    );

    // Close the popup
    window.close();

    // If window.close() didn't work (e.g. tab instead of popup), redirect home
    setTimeout(() => {
      window.location.href = '/search';
    }, 1500);
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin mx-auto mb-4" />
        <p className="text-gray-600 text-sm">Authorization complete — closing window...</p>
      </div>
    </div>
  );
}
